export default function Hours() {
  const schedule = [
    { day: 'Monday', hours: '8:00 AM - 6:00 PM', isOpen: true },
    { day: 'Tuesday', hours: '8:00 AM - 6:00 PM', isOpen: true },
    { day: 'Wednesday', hours: '8:00 AM - 6:00 PM', isOpen: true },
    { day: 'Thursday', hours: '8:00 AM - 6:00 PM', isOpen: true },
    { day: 'Friday', hours: '8:00 AM - 6:00 PM', isOpen: true },
    { day: 'Saturday', hours: '8:00 AM - 6:00 PM', isOpen: true },
    { day: 'Sunday', hours: 'Closed', isOpen: false }
  ];

  const currentDay = new Date().toLocaleDateString('en-US', { weekday: 'long' });

  return (
    <section id="hours" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block border border-gray-300 px-4 py-1.5 rounded-full mb-6">
              <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Business Hours</span>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              We&apos;re Here<br />
              <span className="font-light text-gray-600">When You Need Us</span>
            </h2>

            <p className="text-base text-gray-700 leading-relaxed mb-8">
              Our team is available six days a week to serve all your HVAC needs. Whether it&apos;s routine maintenance or an emergency repair, we&apos;re committed to providing prompt, professional service.
            </p>

            <div className="flex items-center space-x-3 bg-green-50 border border-green-200 rounded-xl px-5 py-4 mb-8">
              <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-green-800">Open Now · Closes 6 PM</span>
            </div>

            <a
              href="tel:4433248816"
              className="inline-flex items-center space-x-3 bg-orange-600 text-white px-8 py-4 rounded-full text-base font-medium hover:bg-orange-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
              <span>Call (443) 324-8816</span>
            </a>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-orange-50/30 rounded-2xl p-10 shadow-lg">
            <div className="space-y-4">
              {schedule.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-center justify-between py-4 px-5 rounded-xl transition-all ${
                    item.day === currentDay
                      ? 'bg-orange-600 text-white shadow-md'
                      : 'bg-white text-gray-900'
                  }`}
                >
                  <div className="flex items-center space-x-3">
                    {item.day === currentDay && (
                      <i className="ri-calendar-check-fill text-xl"></i>
                    )}
                    <span className="font-semibold text-base">{item.day}</span>
                  </div>
                  <span className={`text-sm font-medium ${item.isOpen ? '' : 'opacity-60'}`}>
                    {item.hours}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <div className="flex items-start space-x-3">
                <i className="ri-information-line text-orange-600 text-xl mt-0.5"></i>
                <p className="text-sm text-gray-600 leading-relaxed">
                  <strong className="text-gray-900">Emergency Services Available:</strong> For urgent HVAC issues outside business hours, please call our emergency line.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
